<template>
    <v-dialog
        content-class="pa-0"
        v-model="dialog"
        persistent
        max-width="950"
        :retain-focus="false"
        overlay-color="primary"
        overlay-opacity="0.95"
    >
        <v-card v-resize="onResize" style="background: white;">
            <v-row justify="center" class="pt-6 mx-4">
                <v-card
                    elevation="12"
                    class="bg-banner"
                    width="90%"
                    id="banner-edit"
                >
                    <!-- <v-row class="ma-0 pa-0" justify="center">
                        <v-col cols="2" class="pt-8">
                            <v-avatar color="#F3F3F3" class="border-black" size="100" />
                        </v-col>
                    </v-row> -->
                </v-card>
            </v-row>
            <v-card-title>
                <v-row justify="center" class="my-4 title-avatar">
                    <span v-html="$t('profile.edit_skin')"></span>
                </v-row>
            </v-card-title>
            <v-card-text class="px-0 mx-0" style="background-color:white;">
                <v-card
                    elevation="0"
                    class="overflow-y-auto px-6 py-0"
                    :height="cardHeight"
                    style="background: white;"
                >
                    <v-row class="mx-0 px-0" justify="center">
                        <span class="my-4 title-avatar-types">
                            {{ $t('profile.standard_skins') }}
                        </span>
                        <v-col cols="12" class="mt-10 py-10" v-if="!standarSkins" />
                        <v-col
                            cols="12"
                            class="py-0"
                            v-for="(slide, i) in matrix"
                            :key="i"
                            v-else
                        >
                            <v-row
                                class="fill-height"
                                align="center"
                                justify="center"
                            >
                                <v-col
                                    cols="4"
                                    md="2"
                                    v-for="(skin, j) in slide"
                                    :key="j"
                                >
                                    <Skin :skin="skin" :selected="isSkinSelected(skin)" :key="reload" v-on:active="newSelected"></Skin>
                                </v-col>
                            </v-row>
                        </v-col>
                        <span class="my-6 title-avatar-types">
                            {{ $t('profile.special_skins') }}
                        </span>
                        <v-col cols="12" class="mt-10 py-10" v-if="!standarSkins" />
                        <v-col
                            cols="12"
                            class="py-0"
                            v-for="(slide, h) in matrixStore"
                            :key="'slide-'+h"
                            v-else
                        >
                            <v-row
                                class="fill-height"
                                align="center"
                                justify="center"
                            >
                                <v-col
                                    cols="4"
                                    md="2"
                                    v-for="(skin, k) in slide"
                                    :key="'skinE-'+k"
                                >
                                    <Skin :skin="skin" :selected="isSkinSelected(skin)" :key="reload" v-on:active="newSelected" v-on:toBuy="toBuy"></Skin>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card>
            </v-card-text>
            <v-card-actions class="d-flex justify-center py-5">
                <v-row class="ma-0">
                    <v-col cols="5" md="4" offset-md="2">
                        <v-btn
                            color="primary"
                            class="no-uppercase border-radius-1"
                            large
                            block
                            outlined
                            @click="closeModal"
                            :disabled="btnLoading"
                        >
                            {{ $t('profile.leave') }}
                        </v-btn>
                    </v-col>
                    <v-col cols="7" md="4">
                        <v-btn
                            data-cy="editSkin-saveAction-btn"
                            class="no-uppercase bg-gradient-primary border-radius-1"
                            block
                            dark
                            large
                            @click="updateSkin"
                            :loading="btnLoading"
                        >
                            {{ $t('profile.save_changes') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapState } from 'vuex'
import Skin from './Skin.vue'
import UserSkinService from '../../services/userSkin'

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    components:{
        Skin
    },
    data() {
        return {
            btnLoading: false,
            cardHeight: 350,
            paySkins: null,
            reload: 0,
            selectedSkin: {},
            selectedSkinFromDB: {},
            skinPacks: null,
            standarSkins: null,
            toBuySkins: [],
            userSkins: null,
            windowSize: {
                x: 0,
                y: 0
            }
        }
    },
    mounted() {
        this.onResize()
        this.loadData()
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user
        }),
        matrix() {
            if (!this.standarSkins) {
                return null
            }
            return this.listToMatrix(this.standarSkins, 6)
        },
        matrixStore() {
            if (!this.paySkins) {
                return null
            }
            if (!this.userSkins) {
                return null
            }
            const store = JSON.parse(JSON.stringify(this.paySkins))
            const storeSkins = []
            store.forEach((skin) => {
                const skinStore = skin
                const bought = this.userSkins.find(userSkin => Number(userSkin.id) === Number(skin.id))
                skinStore.active = bought !== undefined
                storeSkins.push(skinStore)
            })
            return this.listToMatrix(storeSkins, 6)
        }
    },
    methods: {
        closeModal () {
            this.$emit('close')
            this.selectedSkin = this.selectedSkinFromDB
            this.setDesktop(this.selectedSkin)
            this.reload += 1
        },
        getActiveSkins() {
            UserSkinService.getAllActivePacks()
                .then((response) => {
                    this.skinPacks = response.content
                    this.setFreeSkins(response.content)
                    this.setPaySkins(response.content)
                })
                .catch((error) => console.error(error))
        },
        getSelectedSkin() {
            UserSkinService.getSelectedByUser(
                this.user.id
            )
            .then((response) => {
                this.selectedSkin = response.content
                this.selectedSkinFromDB = response.content
                this.reload += 1
                this.setDesktop(response.content)
            })
            .catch((error) => console.error(error))
        },
        getUserSkins() {
            this.userSkins = null
            UserSkinService.getAllByUserAndFree(
                this.user.id
            )
            .then((response) => {
                this.userSkins = response.content
            })
            .catch((error) => console.error(error))
        },
        isSkinSelected(skin) {
            const isSelected = this.selectedSkin && this.selectedSkin.id === skin.id
            return isSelected
        },
        listToMatrix(list, elementsPerSubArray) {
            const matrix = []
            let i
            let k

            for (i = 0, k = -1; i < list.length; i+=1) {
                if (i % elementsPerSubArray === 0) {
                    k+=1;
                    matrix[k] = [];
                }
                matrix[k].push(list[i]);
            }
            this.slides = matrix
            return matrix;
        },
        loadData() {
            this.getUserSkins()
            this.getActiveSkins()
            this.getSelectedSkin()
        },
        newSelected (skinId) {
            this.selectedSkin = this.searchSkinSelected(skinId)
            this.setDesktop(this.selectedSkin)
        },
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            if (this.windowSize.y < 864) {
                if (this.windowSize.y < 754) {
                    this.cardHeight = 230
                } else {
                    this.cardHeight = 300
                }
            } else {
                this.cardHeight = 350
            }
        },
        searchSkinSelected(skinId) {
            const inStandarGroup = this.standarSkins.find(skinInPack => Number(skinId) === Number(skinInPack.id))
            if (inStandarGroup === undefined && this.userSkins) {
                return this.userSkins.find(userSkin => Number(skinId) === Number(userSkin.id))
            }
            return this.standarSkins.find(skinInPack => Number(skinId) === Number(skinInPack.id))
        },
        setDesktop(skin) {
            if (!skin || !this.dialog) {
                return
            }
            const img = skin.resources.find((res) => res.resourceUrl.includes('desktop'))
            const cardBanner = document.getElementById("banner-edit")
            const booksBanner = document.getElementById("skinBooks")
            const perfilBanner = document.getElementById("skinPerfil")
            cardBanner.style.backgroundImage = `url("https://assets.beeverso.org/skins/${img.resourceUrl}")`
            booksBanner.style.backgroundImage = `url("https://assets.beeverso.org/skins/${img.resourceUrl}")`
            perfilBanner.style.backgroundImage = `url("https://assets.beeverso.org/skins/${img.resourceUrl}")`
        },
        setFreeSkins(data) {
            const freeSkinPacks = data.filter( (item) => item.type === 'FREE')
            const freeSkins = []

            freeSkinPacks.forEach((skinPack) => {
                freeSkins.push(...skinPack.skins)
            })

            this.standarSkins = freeSkins
        },
        setPaySkins(data) {
            const toPaySkinPacks = data.filter( (item) => item.type === 'PAY')
            const paySkins = []

            toPaySkinPacks.forEach((skinPack) => {
                paySkins.push(...skinPack.skins)
            })

            this.paySkins = paySkins
        },
        toBuy (skin) {
            this.$emit('purchase', skin)
        },
        async updateSkin () {
            this.btnLoading = true
            this.selectedSkinFromDB = this.selectedSkin
            await UserSkinService.selectUserSkin(
                this.user.id,
                this.selectedSkin.id
            )
            .then(() => {
                this.$emit('newSkin', this.selectedSkinFromDB.id)
            })
            .catch((error) => console.error(error))
            this.btnLoading = false
            this.closeModal()
        }
    },
    watch: {
        dialog() {
            setTimeout(() => {
                this.setDesktop(this.selectedSkin)
            }, 500)
            if (this.dialog && this.reload>0) {
                setTimeout(() => {
                    this.loadData()
                }, 100)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.border-black {
    border: 1px solid;
    border-color: black !important;
}
.bg-banner {
    background: rgb(84,63,157);
    background: linear-gradient(90deg, rgba(84,63,157,1) 0%, rgba(145,121,215,1) 50%, rgba(84,63,157,1) 100%);
    border-radius: 20px;
    background-position: 50% 0%;
    background-size: cover;
    height: 25vh;
    @media screen and (max-width: 600px) {
        height: 15vh;
    }
}
.color-primary {
    color: #514773;
}
.color-text {
    color: #4A3216;
}
.no-uppercase {
     text-transform: none;
}
.custom5cols {
  width: 20%;
  max-width: 20%;
  flex-basis: 20%;
}
.title-avatar {
  color: #323A46;
  font-size: 1.75rem;
  @media screen and (max-width: 600px) {
    font-size: 1.2rem;
  }
}
.title-avatar-types{
  color: #323A46;
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: -0.02em;
}
</style>
